import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'empName',
      label: '业务员姓名',
      type: 'input',
      placeholder: '请输入业务员姓名'
    },
    {
      field: 'deptId',
      type: 'select',
      label: '组别',
      placeholder: '请选择组别',
      filterable: true,
      clearable: true,
    },
    {
      field: 'lastMonthSalesAmountType',
      type: 'select',
      label: '上个月业绩',
      clearable: true,
      placeholder: '请选择上个月业绩',
      options: [
        {title: '没有业绩', value: '0'},
        {title: '小于6万', value: '1'},
        {title: '小于10万', value: '2'}
      ]
    },
    {
      field: 'lastMonthSalesFlag',
      type: 'select',
      label: '上月业绩是否达标',
      clearable: true,
      placeholder: '请选择上月业绩是否达标',
      options: [
        {title: '未达标', value: '0'},
        {title: '达标', value: '1'}
      ]
    },
    {
      field: 'firstCreatedAtSalesAmountType',
      type: 'select',
      label: '客户加入当日的业绩',
      clearable: true,
      placeholder: '请选择客户加入当日的业绩',
      options: [
        {title: '没有业绩', value: '0'},
        {title: '小于1万', value: '1'}
      ]
    },
    {
      field: 'contactDeadlineSalesAmountType',
      type: 'select',
      label: '联系截止日的业绩',
      clearable: true,
      placeholder: '请选择联系截止日的业绩',
      options: [
        {title: '没有业绩', value: '0'},
        {title: '小于1万', value: '1'},
      ]
    },
    {
      field: 'isPhoneCommunicationFlag',
      type: 'select',
      label: '是否电话沟通',
      clearable: true,
      placeholder: '请选择是否电话沟通',
      options: [
        {title: '在截止时间内未联系', value: '0'},
        {title: '在截止时间内已联系', value: '1'}
      ]
    },
    // {
    //   field: 'timeSlot',
    //   type: 'datepicker',
    //   label: '通话时间段',
    //   otherOptions: {
    //     startPlaceholder: '开始时间',
    //     endPlaceholder: '结束时间',
    //     type: 'daterange',
    //     'value-format': 'YYYY-MM-DD',
    //     disabledDate: (date: Date) => {
    //       const sixMonthsAgo = new Date();
    //       sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
    //       return date.getTime() < sixMonthsAgo.getTime();
    //     }
    //   }
    // },
    {
      field: 'sysDate',
      type: 'datepicker',
      label: '查询日期',
      otherOptions: {
        placeholder: '选择日期',
        type: 'date',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
